import { Component, OnInit } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-hr-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './hr-file-manager.component.html',
  styleUrl: './hr-file-manager.component.scss'
})
export class HrFileManagerComponent implements OnInit {
  hrInitialPath: string = 'hr';

  ngOnInit(): void {
    console.log('[HrFileManagerComponent] hrInitialPath:', this.hrInitialPath);
  }
}
